import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { AudienceCard } from './features/AudienceCard';
const listVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
export function FeaturesSection() {
  const forWho = ['Profesionales con poco tiempo', 'Emprendedores que quieren automatizar sus tareas', 'Estudiantes que buscan organizar su aprendizaje', 'Creadores de contenido que necesitan ideas constantes', 'Cualquiera que quiera optimizar su vida diaria con IA'];
  const notForWho = ['Personas que no están dispuestas a probar nuevas herramientas', 'Quienes buscan una guía teórica sin ejemplos prácticos', 'Los que no se sienten cómodos experimentando con IA', 'Aquellos que prefieren métodos tradicionales sin tecnología'];
  return <section id="que-incluye" className="py-24 px-6 bg-[#0A0A0A] relative border-t border-[#D4AF37]/10" data-id="element-231">
      <div className="max-w-5xl mx-auto" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-233">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#E8E0D0] mb-4" data-id="element-234">
            ¿Es para ti esta guía?
          </h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto rounded-full" data-id="element-235"></div>
        </motion.div>

        {/* Audience Split */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-236">
          <AudienceCard type="for" title="Para quién es" items={forWho} icon={<CheckCircle2Icon className="w-7 h-7" data-id="element-238" />} data-id="element-237" />
          <AudienceCard type="not-for" title="Para quién NO es" items={notForWho} icon={<XCircleIcon className="w-7 h-7" data-id="element-240" />} data-id="element-239" />
        </div>
      </div>
    </section>;
}